export * from './filter-popover';
export * from './filterComponent';

import { Button, Icon, PopoverScrollable } from '@fox/atoms';
import { useTheme } from 'styled-components';
import { useAutoDataGridContext } from '../../auto-data-grid/context';
import { FilterPopover } from './filter-popover';

export function ToolbarFilter(props: { columns }) {
	const { filters } = useAutoDataGridContext();
	const { columns } = props;

	const theme = useTheme();
	let numAppliedFilters = filters.length;

	return (
		<PopoverScrollable overlay={<FilterPopover columns={columns} />} placement="bottom-start">
			<Button
				startIcon={<Icon iconName={'FilterAlt'} />}
				//variant={'text'}
				title="Filter columns"
				style={{ color: theme.colors.font, backgroundColor: numAppliedFilters === 0 ? '' : theme.colors.grey[200] }}
				sx={{
					'&:hover': {
						opacity: numAppliedFilters === 0 ? 'unset' : '0.8 !important'
					}
				}}
			>
				{numAppliedFilters === 0 ? '' : numAppliedFilters} Filter{numAppliedFilters > 1 && 's'}
			</Button>
		</PopoverScrollable>
	);
}
